module.exports = __webpack_public_path__ + "static/media/27.28caddc7.svg";